import * as React from 'react'
import clx from 'classnames'
import { SquareAlertIcon } from '../icons/SquareAlert'
import { CircleCheckIcon } from '../icons/CircleCheck'
import { CircleAlertIcon } from '../icons/CircleAlert'
import { TriangleAlertIcon } from '../icons/TriangleAlert'
import { CircleInfoIcon } from '../icons/CircleInfo'

type Shape = 'triangle' | 'circle' | 'square'
type Variant = 'alert' | 'check' | 'info'

type Props = {
  shape?: Shape
  variant?: Variant
  badgeContent?: string | number
  className?: string
  iconClassName?: string
  icon?: React.ReactNode
  fillColor?: string
}

type IconCompType = React.FC<{ fill?: string; className?: string }>

const shapeIcons: Record<Shape, Record<Variant, IconCompType | null>> = {
  triangle: {
    alert: TriangleAlertIcon,
    check: null,
    info: null,
  },
  circle: {
    alert: CircleAlertIcon,
    check: CircleCheckIcon,
    info: CircleInfoIcon,
  },
  square: {
    alert: SquareAlertIcon,
    check: null,
    info: null,
  },
}

export const IconWithBadge = ({
  shape = 'circle',
  variant = 'alert',
  badgeContent,
  className,
  iconClassName,
  icon,
  fillColor,
}: Props) => {
  const IconComponent = shapeIcons[shape][variant]

  const renderIcon = () => {
    if (icon) {
      return <span className={clx(iconClassName)}>{icon}</span>
    }

    const effectiveClass = clx(iconClassName)
    return <IconComponent className={effectiveClass} fill={fillColor} />
  }

  return (
    <div
      className={clx('tw-inline-flex tw-items-center tw-gap-0.5 tw-min-w-max', className)}
    >
      <div className="tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-text-inherit">
        {renderIcon()}
      </div>
      {badgeContent != null && <span>{badgeContent}</span>}
    </div>
  )
}
